<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
  tabindex="0"
>
  <div class="icon-text">
   <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/value.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>
    <h2>VALOR DA OBRA</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn_valor"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>

<div class="dropdown-tipo-obra" *ngIf="dropdown.isOpen">
  <div class="form-check valor-obra">
    <div class="value-select value-first">
      <select id="selectValorDe" [value]="valorDeSelecionado" (change)="onValorDeChange($event)"  [class.disabled]="disabled" [disabled]="disabled">
        <option [value]="null" disabled>Indiferente</option>
        <option *ngFor="let valor of dataValorObraDe" [value]="valor.id">
          {{ valor.description }}
        </option>
      </select>
    </div>
    <div class="value-select value-last">
      <select id="selectValorAte" [value]="valorAteSelecionado" (change)="onValorAteChange($event)" [class.disabled]="disabled" [disabled]="disabled">
        <option [value]="null" disabled>Indiferente</option>
        <option *ngFor="let valor of dataValorObraAte" [value]="valor.id">
          {{ valor.description }}
        </option>
      </select>
    </div>
  </div>
</div>
